import { DefaultTheme } from 'styled-components'

const theme: DefaultTheme = {
   highlight: 'rgb(71, 157, 255)',
   cells: '#DDD',
   bg: '#FFF',
   text: '#000',
}

export default theme
